import { render, staticRenderFns } from "./DeleteGroup.vue?vue&type=template&id=61e3ad82&scoped=true&"
import script from "./DeleteGroup.vue?vue&type=script&lang=js&"
export * from "./DeleteGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3ad82",
  null
  
)

export default component.exports